import { useParams } from "react-router";
import { usePortfolioCollectionSettings } from "@/lib/hooks/use-portfolio-collections";
import { FormCardSkeleton } from "../skeleton-loaders";
import { CollectionSettings } from "./collection-settings";

export default function SettingsPage() {
  const { id } = useParams<{ id: string }>();
  const { settings, isLoading } = usePortfolioCollectionSettings(id!);

  if (isLoading || !settings) {
    return <FormCardSkeleton fields={2} />;
  }

  return (
    <CollectionSettings
      portfolioCollectionId={id!}
      currency={settings.currency}
      riskFreeRatePct={settings.riskFreeRatePct}
      bankReturnPct={settings.bankReturnPct}
      requiresAssetAllocation={settings.requiresAssetAllocation}
      requiresTimeseries={settings.requiresTimeseries}
      financialSituationModelId={settings.financialSituationModelId}
      enforceMinBuyAmounts={settings.enforceMinBuyAmounts}
      dynamicPortfoliosEnabled={settings.dynamicPortfoliosEnabled}
      dynamicPartialReplacementEnabled={settings.dynamicPartialReplacementEnabled}
      allowModelPortfolioRiskDeviation={settings.allowModelPortfolioRiskDeviation}
      wrapperTypesEnabled={settings.wrapperTypesEnabled}
      productTypesEnabled={settings.productTypesEnabled}
      calculationsMode={settings.calculationsMode}
      requiresIsin={settings.requiresIsin}
      riskModelId={settings.riskModelId}
      riskModel={settings.riskModel}
    />
  );
}
